import React from "react";
import { AccountDetailsTable } from "./AccountDetailsTable";
import { AssociateConcernDetailsTable } from "./AssociateConcernTable";
import { AssociateConcernDirectorDetailsTable } from "./AssociateDirectoryProprietorTable";
import { CollateralSecurityDetailsTable } from "./CollateralSecurityTable";
import { DirectorPartnerDetailsTable } from "./DirectoryPartnerTable";
import BorrowerGroupTable from "./BorrowerGroupTable";
import GovernmentSchemesTable from "./GovernmentSchemesTable";
import { PerpetratorDetailsTable } from "./PerpetratorDetailsTable";
import ScbmfComplianceTable from "./ScbmfComplianceTable";
import { StaffSideActionTable } from "./StaffSideActionTable";
import TpspDetailsTable from "./TpspDetailsTable";


const FMR1Part2Tab: React.FC = () => (
  <div className="p-3 pb-20 overflow-auto flex flex-col gap-6">
    <StaffSideActionTable />
    <AccountDetailsTable />
    <PerpetratorDetailsTable />
    <DirectorPartnerDetailsTable />
    <AssociateConcernDetailsTable />
    <AssociateConcernDirectorDetailsTable />
    <CollateralSecurityDetailsTable />
    <ScbmfComplianceTable />
    <GovernmentSchemesTable />
    <BorrowerGroupTable />
    <TpspDetailsTable />
  </div>
);

FMR1Part2Tab.displayName = "FMR1Part2Tab";

export default FMR1Part2Tab;
